export const MONITORING_TABLE_PAGE_SIZE = 20;
/** Refetch all monitoring log endpoints while the tab is open. */
export const MONITORING_POLL_INTERVAL_MS = 60_000;
export const CHART_HEIGHT = 380;
/** Lookback for hourly / risk-score charts (backend default is 1 day). */
export const CHART_DAYS = 7;
export const USAGE_ALERT_THRESHOLD = 650;
export const ALERTS_TAB_CHART_HEIGHT = 380;

export const CHART_HEADINGS = {
  apiCallsByHour: 'Monitor: Production API Calls by Hour',
  riskScoresByHour: 'Monitor: Responsible AI Risk Scores by Hour',
  costByProject: 'Monitor: Estimated API Cost by Project',
  alertsSeverity: 'Alerts: Open Events by Severity',
  alertsControl: 'Alerts: Events by Control / Metric',
  apiRequestLog: 'Monitor: API Requests'
} as const;

export const EMPTY_MESSAGES = {
  chart: 'No chart data yet',
  apiTable: 'No API requests to display',
  summaryUnavailable: 'Monitoring data unavailable',
  loadingSummary: 'Loading monitoring metrics…',
  summaryErrorFallback: 'Unable to load monitoring summary.'
} as const;
